<!-- TODO: I copied this over from the OG sidebar, and browserIsSafari is never set??? - [ngClass]="{ 'add-on-container-center': browserIsSafari }" -->
<ng-container *ngIf="addOnOptions$ | async as addOnOptionsLoadable">
  <ng-container [ngSwitch]="addOnOptionsLoadable.status">
    <ng-container *ngSwitchCase="LoadableStatus.LOADED">
      <div *ngIf="addOnOptionsLoadable.data?.length" class="d-flex align-items-center">
        <button
          andButton
          color="hyperlink"
          class="me-1 p-0"
          (click)="openAdditionalServiceDialog(addOnOptionsLoadable.data)"
          data-cy="add-on-button"
        >
          Pay for additional service(s)
        </button>

        <!-- info icon -->
        <aiwyn-icon
          name="info"
          data-cy="add-on-info-icon"
          tooltip="If your invoice indicates optional add-ons or you have an invoice not listed, you can add that here."
        ></aiwyn-icon>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="LoadableStatus.ERROR"></ng-container>

    <!-- TODO REFACTOR: Maybe bring this back if Joshua wants a loading state. -->
    <!--<ng-container *ngSwitchDefault>
      <mat-progress-bar></mat-progress-bar>
    </ng-container>-->
  </ng-container>
</ng-container>
